var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        'scroll-top',
        { 'scroll-top--hidden' : !_vm.isShown }
    ]},[_c('button',{staticClass:"scroll-top__btn",on:{"click":_vm.scrollTop}},[_c('z-icon',{attrs:{"name":"btn-arrow","width":"8","height":"16"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }